import { Link } from "react-router-dom";

function Navigation({ className }) {
  return (
    <>
      <div className={`restly-header-main-menu ${className || ""}`}>
        <ul>
          <li>
            <Link to="/">Home</Link>
          </li>
          <li>
            <Link to="/about">About</Link>
          </li>
          <li>
            <Link to="#">
              Products <i className="fa fa-angle-down" />
            </Link>
            <div></div>
            <ul className="sub-menu">
              <li>
                <Link to="/multi/0">Multi GNSS Processor</Link>
              </li>
              <li>
                <Link to="/module/1">Modules</Link>
              </li>
              <li>
                <Link to="/antenna/4">GNSS Antenna</Link>
              </li>

              <li>
                <Link to="/receiver/2">GNSS Receivers</Link>
              </li>
              <li>
                <Link to="/drone/3">Drone Navigation Unit</Link>
              </li>
              <li>
                <Link to="/clock/5">NavIC Clock</Link>
              </li>
              <li>
                <Link to="/map/6">Map Display Systems</Link>
              </li>
              <li>
                <Link to="/tracking/7">Tracking Devices</Link>
              </li>
              <li>
                <Link to="/timing-server/8">NavIC Timing Server</Link>
              </li>
              <li>
                <Link to="/grid-converter/9">Grid Converter</Link>
              </li>
              <li>
                <Link to="/handheld-navigator/10">Handheld Navigator</Link>
              </li>
            </ul>
          </li>
          <li>
            <Link to="/system">Systems</Link>
          </li>
          <li>
            <Link to="/r-and-d">
            R&D</Link>
          </li>
          <li>
            <Link to="/news">News</Link>
          </li>
          <li>
            <Link to="/faq">FAQ</Link>
          </li>
          {/* <li>
            <Link to="/events">Events</Link>
          </li> */}
          <li>
            <Link to="/downloads">Downloads</Link>
          </li>
          <li>
            <Link to="/contact">Contact</Link>
          </li>
          <li>
            <Link to="#">
              Go To <i className="fa fa-angle-down" />
            </Link>
            <ul className="go-to sub-menu">
              <li>
                <Link to="https://elenaivts.com:7443/ivts/" target="_blank">
                  IVTS
                </Link>
              </li>
              <li>
                <Link to="https://sbms.elenageosys.com:7443/login" target="_blank">
                  SBMS
                </Link>
              </li>
              <li>
                <Link to="https://staff.elenageo.in:3333/" target="_blank">
                  Staff Login
                </Link>
              </li>
              {/* <li>
                <Link to="https://mail.elenageo.in:2222/mail/" target="_blank">
                  Internal Mail 
                </Link>
              </li> */}
              {/* <li>
                <Link
                  to="https://eim.elenageosys.com/admin/login/?next=/admin/"
                  target="_blank"
                >
                  Staff Login
                </Link>
              </li> */}
            </ul>
          </li>
        </ul>
      </div>
    </>
  );
}

export default Navigation;
